import { render, staticRenderFns } from "./we-footer-view.vue?vue&type=template&id=5583ffc4&scoped=true&"
import script from "./we-footer-view.vue?vue&type=script&lang=js&"
export * from "./we-footer-view.vue?vue&type=script&lang=js&"
import style0 from "./we-footer-view.vue?vue&type=style&index=0&id=5583ffc4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5583ffc4",
  null
  
)

export default component.exports